<template>
  <div>
    <div class="overflow-hidden">
      <category-filter
        v-for="(filter, index) in category.facets"
        :key="`${index}-${filter.min || ''}-${filter.max || ''}`"
        :value="getFilterValue(filter)"
        class="mb-10"
        :category="category"
        :filter="filter"
        @input="filterChanged(filter, $event)"
        @click:filter="$gtmEvents.onActivatedFilter(category, $event)"
      />
    </div>
  </div>
</template>

<script>
import IconArrow from '../../general/icons/IconArrow'
import CategoryFilter from './CategoryFilter'

export default {
  components: {
    IconArrow,
    CategoryFilter
  },
  props: {
    category: {
      required: true,
      type: Object
    },
    value: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      filters: JSON.parse(JSON.stringify(this.value || []))
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        if (JSON.stringify(this.value) !== JSON.stringify(this.filters)) {
          this.$emit('input', JSON.parse(JSON.stringify(this.filters)))
        }
      }
    },
    value: {
      deep: true,
      handler () {
        if (JSON.stringify(this.value) !== JSON.stringify(this.filters)) {
          this.filters = JSON.parse(JSON.stringify(this.value))
        }
      }
    }
  },
  methods: {
    filterChanged (filter, event) {
      let existing = this.filters.find(f => f.feature_id === filter.feature_id)
      if (!event.length && existing) {
        this.filters.splice(this.filters.indexOf(existing), 1)
        return
      }
      if (!existing) {
        existing = {
          feature_id: filter.feature_id,
          type: 'term',
          values: event
        }
        this.filters.push(existing)
      }
      existing.values = event
    },
    getFilterValue (filter) {
      const existing = this.filters.find(f => f.feature_id === filter.feature_id)
      return existing ? existing.values : []
    }
  }
}
</script>

<style lang="scss" scoped>
  .sky__filter-color {
    @apply relative;
    &:after {
      @apply block absolute left-0 right-0 top-0 bottom-0 rounded-full cursor-pointer;
      content: '';
      background: rgba(white, 0.4);
    }
    &.selected {
      @apply shadow;
      &:after {
        background: rgba(white, 0);
      }
    }
  }
</style>
